(() => {
  const colorOrder = ['Red','Orange','Yellow','Green','Blue','Purple/Lavender','Pink','Brown/Tan','Black','Gray','White/Cream/Clear','Multicolor'];
  const tags = value => (value || '').split(',').map(x => x.trim()).filter(Boolean);
  const init = root => {
    if (root.dataset.lapReady) return;
    const selects = ['state','kind','color'].map(key => root.querySelector(`[data-lap-${key}]`));
    const cards = [...root.querySelectorAll('[data-state][data-kind]')];
    if (selects.some(select => !select)) return;
    const keys = ['state','kind','colors'];
    selects.forEach((select,i) => {
      select.querySelectorAll('option').forEach(option => { if (option.value) option.remove(); });
      const values = [...new Set(cards.flatMap(card => tags(card.dataset[keys[i]])))];
      values.sort((a,b) => i === 2 ? colorOrder.indexOf(a)-colorOrder.indexOf(b) : a.localeCompare(b));
      values.forEach(value => { const option=document.createElement('option'); option.value=value; option.textContent=value; select.append(option); });
    });
    if (root.dataset.defaultState && [...selects[0].options].some(o => o.value === root.dataset.defaultState)) selects[0].value=root.dataset.defaultState;
    const count=root.querySelector('[data-lap-count]'), empty=root.querySelector('[data-lap-empty]');
    root.dataset.lapReady='true';
    const controls=root.querySelector('.cc2-lap-filters');
    if (controls) controls.hidden=false;
    const filter=() => {
      let n=0;
      cards.forEach(card => {
        card.hidden=selects.some((select,i) => select.value && !tags(card.dataset[keys[i]]).includes(select.value));
        if (!card.hidden) n++;
      });
      if (count) count.textContent=n+' '+count.dataset.label;
      if (empty) empty.hidden=n!==0;
    };
    selects.forEach(select => select.addEventListener('change',filter));
    filter();
  };
  document.querySelectorAll('[data-lap-library]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-lap-library]').forEach(init));
})();
